<template>
    <el-container class="task" v-wechat-title="$route.meta.title">
        <el-main>
            <!-- <TaskPrice :data="taskListData" :positionData="totalTaskData"></TaskPrice> -->
            <div class="task-box">
                <div class="task-header column-header">
                    <div class="task-header-left">
                        <span>计划任务</span>
                        <span style="color: #DA5634">( {{taskRunIdList.length}} / {{taskList.length}} )</span>
                    </div>
                    <div class="task-header-right">
                        <!-- <el-button @click="lockTaskList('sub')"><i class="fa fa-minus-circle" aria-hidden="true"></i></el-button>
                        <el-button @click="lockTaskList('add')"><i class="fa fa-plus-circle" aria-hidden="true"></i></el-button> -->
                        <el-slider v-model="widthIndex" @input="taskWidthEvent" :min="min" :max="max"></el-slider>
                        <span class="loadding-more" v-if="loadingMore"><i class="el-icon-loading"></i></span>
                        <span class="task-batch" title="批量操作" v-if="!loadingMore">
                            <el-dropdown class="task-list-btn" trigger="click">
                                <el-button class="btn__style"><i class="fa fa-plus-square-o" aria-hidden="true"></i></el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-if="selectAllFlag" @click.native="selectAll(true)">全部选中</el-dropdown-item>
                                    <el-dropdown-item v-else @click.native="selectAll(false)">全部取消</el-dropdown-item>
                                    <el-dropdown-item @click.native="taskContral(2)">启动</el-dropdown-item>
                                    <el-dropdown-item @click.native="taskContral(4)">停止</el-dropdown-item>
                                    <el-dropdown-item @click.native="taskContral(3)">暂停</el-dropdown-item>
                                    <el-dropdown-item @click.native="taskConfigL()">配置</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </span>
                        <el-button class="btn__style" @click="showAddTask('add')">添加任务</el-button>
                    </div>
                    <!-- 添加任务与配置任务 -->
                    <el-dialog :visible.sync="dialogVisible.visible" width="45%">
                        <AddTask v-if="taskFlag == 'add'" :key="menuKey"></AddTask>
                        <TaskConfig v-else-if="taskFlag == 'config'" :taskData="taskStatus" ref="taskConfig"></TaskConfig>
                        <TaskConfigs v-else-if="taskFlag == 'configs'" ></TaskConfigs>
                    </el-dialog>
                </div>
                <div class="task-list">
                    <div class="task-list-table">
                        <div class="task-list-table-left">
                            <div class="task-filter-box">
                                <div class="filter-box-item" v-for="(item, index) in currencyList" :key="'currency-'+index" @click="currencyFilterEvent(item)">
                                    <button class="filter-box__text" :class="{'filterActive': filterCurrencyColor(item)}">{{item}}</button>
                                </div>
                            </div>
                            <div class="task-filter-box">
                                <div class="filter-box-item" v-for="(item, index) in typeFilterList" :key="'type-'+index" @click="bourseTypeSelectEvent1(item)">
                                    <button class="filter-box__text" :class="{'filterActive': filterTypeColor(item)}">{{item}}</button>
                                </div>
                            </div>
                            <div class="task-filter-box">
                                <div class="filter-box-item" v-for="(strategy, index) in strategyList" :key="'strategy-'+index" @click="strategySelect(strategy['name'])">
                                    <button class="filter-box__text" :style="{'color': filterStrategyColor(strategy['name'])}">{{strategy.name}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="task-list-table-mobile">
                        <select v-model="typeFilter" @change="currencySelectEvent">
                            <option v-for="(item, index) in currencyList" :key="'s1'+index" :value="item">{{item}}</option>
                        </select>
                        <select v-model="typeJudge" @change="typeSelectEvent">
                            <option v-for="(item, index) in typeFilterList" :key="'s2'+index" :value="item">{{item}}</option>
                        </select>
                    </div>

                    <div class="test" v-if="!taskLoad">
                        <div class="task-item-box" v-for="(task, index) in filterList" :key="index" :style="{'display': taskIsShow(task)}">
                            <TaskInfo v-if="isRender(task)" :taskData="task" ref="child" :analisisData="analisisData" @showChartEvent="showTaskChart"></TaskInfo>
                        </div>
                    </div>
                    <div class="test-loading" v-else>
                        <div class="loadding-task"><i class="el-icon-loading"></i></div>
                    </div>

                </div>
                <!-- 任务图标表-->
                <el-dialog :visible.sync="chartDialogVisible" width="50%" class="market-chart-dialog">
                    <div class="dialog-header">
                        <h3 v-if="thisCurrency.aCurrencys">{{thisCurrency.aCurrencys[0]}}</h3>
                    </div>
                    <el-divider></el-divider>
                    <div class="dialog-content">
                        <div class="chart-time-select">
                            <span :style="{'color': chartTimeColor('1T')}" @click="chartTimeSelect('1T')">1T</span>
                            <span :style="{'color': chartTimeColor('30T')}" @click="chartTimeSelect('30T')">30T</span>
                            <span :style="{'color': chartTimeColor('1H')}" @click="chartTimeSelect('1H')">1H</span>
                            <span :style="{'color': chartTimeColor('4H')}" @click="chartTimeSelect('4H')">4H</span>
                            <span :style="{'color': chartTimeColor('1D')}" @click="chartTimeSelect('1D')">1D</span>
                            <span :style="{'color': chartTimeColor('1W')}" @click="chartTimeSelect('1W')">1W</span>
                        </div>
                        <MarketChart ref="marketChart"></MarketChart>
                    </div>
                </el-dialog>
            </div>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import Header from '@/components/header/Header.vue'
import Footer from '@/components/Footer/New-footer.vue'
import TaskInfo from '@/views/task/task-info.vue'
import AddTask from '@/views/task/Add-task.vue'
import CtaskInfo from '@/views/task/Ctask-info.vue'
import TaskConfig from '@/views/task/task-config.vue'
import TaskPrice from '@/views/task/task-left/Task-total-price.vue'
import TaskConfigs from '@/views/task/Task-configs.vue'
import MarketChart from '@/views/market/MarketChart.vue'
import { mapState, mapActions } from 'vuex'
import { taskWaitTimer, url_CM } from '@/api/config'
import { get, put } from '@/api/index'
import { numToCStr, deepClone } from '@/utils/common'

export default {
    components: {
        Header,
        Footer,
        TaskInfo,
        AddTask,
        CtaskInfo,
        TaskConfig,
        TaskPrice,
        MarketChart,
        TaskConfigs
    },
    data() {
        return {
            reFresh: true,
            addTaskEvent: [],
            menuKey: 1,
            taskFlag: 'add',
            taskStatus: '',
            taskData: {},
            currencyFilter: '',
            typeFilterList: ['全部', '现/本', '现/次', '现/季', '现/永', '本/次', '本/季', '本/永', '次/季', '次/永', '季/永'],
            currencyList: ['全部', 'BTC', 'ETH', 'BCH', 'EOS', 'ETC',  'XRP', 'LTC', 'TRX', 'BSV'],
            typeSelect: '全部',
            typeFilter: '全部',
            bourseTypeSelect: '全部',
            bourseTypeTrueSelect: '全部',
            tradeNum: {0: 98, 1: 180},
            selectAllFlag: true,
            checkAllFlag: false,
            typeJudge: '全部',
            chartDialogVisible: false,

            testList: [],
            thisCurrency: '',
            chartTimeFlag: '1T',
            chartData: {},
            analisisData: {},
            testSocket: null,
            positionTimer: null,
            timeTimer: null,
            isLock: false,
            delayTimer: null,
            widthIndex: 440,
            min: 320,
            max: 500,
            loadingMore: false,
            taskLoad: false,
            bourseTypeObj: {},
            strategySelectName: '套利2',
            checkTaskList: [],
        }
    },
    watch: {
        menuKey() {
            // 重新渲染组件
            console.info('reFresh')
        },
    },
    
    mounted() {
        // this.taskLoad = true;
        this.getTaskList().then(data => {
            this.calTaskWidth();
            this.getStrategyList();
            this.getApiList();
            this.createWebSocket();
        });

        this.getCurrencyNum().then(() => {// 获取交易类型

        })

        this.$once('hook:beforeDestroy', () => {
            this.$store.commit('initTaskBoxSelect', []);
        })

        window.addEventListener('beforeunload', e => {
            clearInterval(this.taskTimer['positionTimer']);
        })
        let that = this
        window.onresize = function () {
            that.calTaskWidth()
        }
    },
    beforeDestroy() {
        clearInterval(this.taskTimer['getTaskListTimer'])
    },
    computed: {
        ...mapState([
            'taskList',
            'dialogVisible',
            'taskSelect',
            'cTaskList',
            'token',
            'taskWebSocket',
            'allTaskIdList',
            'taskWbtTimer',
            'taskRunIdList',
            'currencyNum',
            'apiNameList',
            'taskBoxSelect',
            'taskInfoSocket',
            'taskPageFlag',
            'taskTimer',
            'strategyList',
            'ctaskWidth'
        ]),

        // 计算任务的总持仓额
        totalTaskData: function () {
            var total_have_position_0 = 0;
            var total_have_position_1 = 0;
            var total_used_position = 0;
            for (var i in this.taskData) {
                // 遍历主任务
                var task_data = this.taskData[i];
                // console.log(task_data);
                for (var j in task_data) {
                    // 每个子任务
                    if (j == 'fic') continue;
                    var ctask_data = task_data[j];
                    total_have_position_0 += Number(ctask_data['mt'][0]);
                    total_have_position_1 += Number(ctask_data['mt'][1]);
                    if (ctask_data.hasOwnProperty('f')) {
                        if (typeof ctask_data['f'][1][1] == 'undefined') {
                            var ctask_postion = 0;
                        } else {
                            var ctask_postion = ctask_data['f'][1][1];
                        }
                        total_used_position += Number(ctask_postion);
                    } 
                    if (ctask_data.hasOwnProperty('r')) {
                        if (typeof ctask_data['r'][1][1] == 'undefined') {
                            var ctask_postion = 0;
                        } else {
                            var ctask_postion = ctask_data['r'][1][1];
                        }
                        total_used_position += Number(ctask_postion);
                    }
                }
            }
            return total_used_position + '/(' + total_have_position_0+'+' + total_have_position_1 + ')';
        },

        // 计算每个币种的利润
        taskListData: function () {
            var pro_currency = {};
            if (this.taskList.length > 0) {
                this.taskList.map(value => {
                    pro_currency[value.params.currency_type] = 0;
                })
                for (var i=0; i<this.taskList.length; i++) {
                    var task_id = this.taskList[i].id;
                    var task_currency = this.taskList[i].params.currency_type;
                    if (JSON.stringify(this.taskData) !== '{}') {
                        var task_data = this.taskData[task_id];
                        for (var key in task_data) {
                            var ctask_data = task_data[key];
                            if (typeof ctask_data['pro_count'] == 'undefined') {
                                var pro_count = 0;
                            } else {
                                var pro_count = Number(ctask_data['pro_count']);
                            }
                            pro_currency[task_currency] += pro_count;
                        }
                    }
                }
                return pro_currency;
            }
        },

        // 任务列表优化
        filterList: function () {
            let fileter_list = [];
            let check_list = []
            for (let i=0; i<this.taskList.length; i++) {
                if (this.taskList[i]['strategy_name'] == this.strategySelectName) {
                    fileter_list.push(this.taskList[i])
                    check_list.push(this.taskList[i]['id'])
                }
            }
            // this.checkTaskList = fileter_list;
            this.checkTaskList = deepClone(check_list)
            return fileter_list;
        }
    },
    methods: {
        ...mapActions([
            'getTaskList',
            'getCtaskArray',
            'createTaskSocket',
            'getCurrencyNum',
            'getApiList',
            'getStrategyList'
        ]),

        // 展示添加主任务
        showAddTask(flag, status, strategyName) {
            this.taskFlag = flag;
            this.dialogVisible.visible = true;
            
            this.menuKey ++;
            if (this.taskFlag == 'config') {
                this.$nextTick(() => {
                    this.$refs.taskConfig.getTaskParam(strategyName);
                })
            } else if (this.taskFlag == 'configs') {

            }
            if (typeof status !== 'undefined') {
                this.taskStatus = status;
            }
        },

        // 展示子任务
        showCtask(index, e) {
            if (e.target == e.currentTarget) {
                this.$refs.child[index].showCtask()
            }
        },
        
        /**
         * websocket 函数
         */

        createWebSocket() {
            if (this.taskInfoSocket.testSocket && this.taskInfoSocket.testSocket.readyState == 1) {// 如果 testSocket 存在
                // 清除延时器
                this.socketOpen();
            } else {
                this.taskInfoSocket.testSocket = new WebSocket('ws://'+url_CM.split('//')[1]+'/ts/websocket');
                console.log('websocekt 连接成功', this.taskInfoSocket.testSocket.readyState);
                this.initTestSocket();
            }
        },

        // 测试 初始化websocket
        initTestSocket() {
            this.taskInfoSocket.testSocket.onopen = this.socketOpen;
            this.taskInfoSocket.testSocket.onmessage = this.getSocketMsg;
            this.taskInfoSocket.testSocket.onerror = this.socketError;
            this.taskInfoSocket.testSocket.onclose = this.socketClose;
        },

        // websocket接收函数
        getSocketMsg(resp) {
            if (resp.data !== 'ok') {
                var real_reap = JSON.parse(resp.data)
                this.taskData = real_reap.position;
                this.$store.commit('initTaskPosition', real_reap.position);
                this.$store.commit('setTaskCloseData', real_reap.muldata);
                this.$store.commit('setTaskChangeable', real_reap.changeable);
                this.analisisData = real_reap.analysis;
                this.$store.commit('setTaskStatusList', real_reap.status)
            }
        },

        // websocket send函数
        socketOpen() {

            // 仓位请求
            var param = {
                'token': this.token,
                'data': this.allTaskIdList
            } 
            var param1 = {
                'sign': 'analysis',
                'data': this.taskRunIdList
            }
            this.taskInfoSocket.testSocket.send(JSON.stringify(param));

            this.taskTimer['positionTimer'] =  setInterval(() => {
                this.taskInfoSocket.testSocket.send(JSON.stringify(param));
            }, 3000)


            // 组件销毁时，清除定时器
            this.$once('hook:beforeDestroy', () => {
                clearInterval(this.taskTimer['positionTimer'] );
                // clearInterval(this.taskTimer['timeTimer']);
            })
        },

        // websocket error函数
        socketError(e) {
            clearInterval(this.positionTimer);
            // clearInterval(this.timeTimer);
            console.warn('WebSocket：', e);
        },

        // websocket 关闭函数
        socketClose(e) {
            clearInterval(this.positionTimer);
            // clearInterval(this.timeTimer);
            console.warn('webSocket 连接关闭：', e.code);
        },


        // 任务筛选
        taskIsShow(data) {
            var currency = data.params.currency_type; // 币种
            var a_bourse_type = data.params.a_transaction_type; // a 交易类型
            var b_bourse_type = data.params.b_transaction_type; // b 交易类型
            var type_show = true; // 交易类型是否显示
            var currency_show = true; // 币种是否显示


            // 判断币种是否显示 显示为true, else false
            if (this.bourseTypeTrueSelect == '全部') {
                type_show = true; 
            } else {
                if (this.bourseTypeTrueSelect.indexOf(a_bourse_type) !== -1 && this.bourseTypeTrueSelect.indexOf(b_bourse_type) !== -1) {
                    // 两个 交易类型都存在时, 表示可以显示
                    type_show = true;
                } else {
                    type_show = false;
                }
            }
            // 判断交易类型是否显示 显示为true, else false
            if (this.typeFilter == '全部') {
                currency_show = true;
            } else {
                if (this.typeFilter == currency) {// 两个币种相同时，显示
                    currency_show = true;
                } else {
                    currency_show = false;
                }
            } 
            
            var this_index = this.taskBoxSelect.indexOf(data.id);
            // 综合两个条件筛选
            if (type_show && currency_show) {// 两个选项都为 true 时，才显示
                if (this.checkAllFlag == true) {// 全选
                    if (this_index == -1 && this.checkTaskList.length == this.taskBoxSelect) {// id 不在 taskBox, 则添加
                        this.taskBoxSelect.push(data.id);
                    }
                }
                return '';
            } else {
                if (this.checkAllFlag == true) {// 全选
                    if (this_index !== -1) {// 此任务在 taskbox 列表里, 删除该任务id
                        this.taskBoxSelect.splice(this_index, 1);
                    }
                }
                return 'none';
            }
            
        },

        // 根据币种筛选任务
        currencyFilterEvent(currency) {
            this.typeFilter = currency;
        },

        // 根据币种筛选任务 mobile
        currencySelectEvent() {

        },

        // 交易类型选择事件
        bourseTypeSelectEvent1(data) {
            this.typeJudge = data;
            if (data == '全部') {
                this.bourseTypeTrueSelect = '全部';
            } else {
                var type_list = data.split('/');
                // 将中文转换为数字字符串
                var type_1 = this.strToNum(type_list[0]);
                var type_2 = this.strToNum(type_list[1]);
                this.bourseTypeTrueSelect = type_1 + ':' + type_2;
            }
        },

        // 交易类型筛选任务
        typeSelectEvent() {
            if (this.typeJudge == '全部') {
                this.bourseTypeTrueSelect = '全部';
            } else {
                var type_list = this.typeJudge.split('/');
                // 将中文转换为数字字符串
                var type_1 = this.strToNum(type_list[0]);
                var type_2 = this.strToNum(type_list[1]);
                this.bourseTypeTrueSelect = type_1 + ':' + type_2;
            }
        },

        // 交易类型 中文转换为数字字符串
        strToNum(data) {
            if (data == '本') return this.currencyNum['CW'];
            else if (data == '次') return this.currencyNum['NW'];
            else if (data == '季') return this.currencyNum['CQ'];
            else if (data == '现') return '现货';
            else if (data == '永') return '永续';
            return data;
        },

        // apiId 转换为 名字
        apiIdToName(id) {
            for (var i in this.apiNameList) {
                if (this.apiNameList[i].id == id) {
                    return this.apiNameList[i].name;
                }
            }
        },

        // 勾选、取消勾选 全部
        selectAll(flag) {
            this.selectAllFlag = !this.selectAllFlag;
            this.$store.commit('setCheckBoxFlag', flag);
            var taskNodeList = this.$refs.child;
            this.checkAllFlag = flag;
            for (var i=0; i<taskNodeList.length; i++) {
                taskNodeList[i].allCheckedEvent();
            }
            if (flag == true) {// 全选
                this.$store.commit('initTaskBoxSelect', this.deepClone(this.checkTaskList));
            } else {// 不选
                this.$store.commit('initTaskBoxSelect', []);
            }
        },

        // 任务批量操作
        taskContral(operation) {
            var url = this.$baseUrl + '/task/status/update/batch';
            var param = {
                'token': this.token,
                'taskIds': this.taskBoxSelect,
                'settingStatus': operation
            };

            this.$confirm('是否执行批量操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 确定
                this.loadingMore = true;
                put(url, JSON.stringify(param)).then(resp => {
                    if (resp.code == 200) {
                        this.taskStatusResult(param, operation);
                    } else {
                        this.$notify.error({
                            message: resp.info,
                            title: '提示',
                            offset: 100,
                            duration: 1000
                        })
                    }
                })
            }).catch(() => {});           
        },

        // 任务状态修改 返回结果
        taskStatusResult(param, operation) {
            var url = this.$baseUrl + '/task/status/detection/batch';
            var status_timer = setInterval(() => {
                put(url, JSON.stringify(param)).then(resp => {
                    if (resp.code == 200) {
                        if (resp.data.updateStatusAccomplishing) {// 成功
                            this.getTaskList();
                            clearInterval(status_timer);
                            this.loadingMore = false;
                        } 
                    }
                });
            }, 1000)
        },

        // 币种筛选 高亮
        filterCurrencyColor(data) {
            if (this.typeFilter == data) return '#db5634';
        },
        // 交易类型筛选高亮
        filterTypeColor(data) {
            if (this.typeJudge == data) return '#db5634';
        },

        // 深拷贝
        deepClone(arr) {
            var obj = arr.constructor==Array?[]:{};
            for (var i in arr) {
                if (typeof arr[i] === 'object') {
                    obj[i] = this.deepClone(arr[i]);
                } else {
                    obj[i] = arr[i];
                }
            }
            return obj;
        },

        // 展示任务图表
        showTaskChart(param) {
            this.chartDialogVisible = true;
            this.chartData = param;
            var currency_arr = [];
            var currency_obj = {
                'aCurrencys': [param.aCurrency],
                'bCurrencys': [param.bCurrency],
            }
            this.thisCurrency = currency_obj;
            var bourseObj = {
                "aBourse": param.aBourse,
                "bBourse": param.bBourse
            }
            this.bourseTypeObj = bourseObj;
            this.$nextTick(() => {
                var node = this.$refs.marketChart;
                // $(node).empty();
                node.sortData(currency_obj, param.aType, param.bType, this.chartTimeFlag, bourseObj);
            })
        },

        // chart 时间选择事件
        chartTimeSelect(param) {
            this.chartTimeFlag = param;
            var node = this.$refs.marketChart;
            var bourseObj = {
                "aBourse": this.bourseTypeObj.aBourse,
                "bBourse": this.bourseTypeObj.bBourse
            }
            node.sortData(this.thisCurrency, this.chartData.aType, this.chartData.bType, this.chartTimeFlag, bourseObj);
        },

        // chart 时间颜色判断
        chartTimeColor(param) {
            if (param == this.chartTimeFlag) return '#db5634';
        },

        // 滑动条计算
        taskWidthEvent() {
            var task_list_node = document.getElementsByClassName('task-item-box');
            this.$store.commit('setCtaskWidth', this.widthIndex);
            for (var i=0; i<task_list_node.length; i++) {
                task_list_node[i].style.minWidth = this.widthIndex+'px';
            }
        },

        // 滑动条计算
        formatTooltip(val) {
            return val / 100;
        },

        // 批量配置
        taskConfigL() {
            this.showAddTask('configs')
        },

        // 策略分类选择事件
        strategySelect(data) {
            this.strategySelectName = data;
        },

        // 策略分类高亮
        filterStrategyColor(name) {
            if (name == this.strategySelectName) return '#dad6d6'
        },

        // 是否渲染任务
        isRender(data) {
            // console.log(data);
            let strategy_name = data['strategy_name'];
            if (this.strategySelectName == data['strategy_name']) return true;
            return false;
        },

        // 计算任务宽度
        calTaskWidth() {
            let task_node = document.getElementsByClassName('task-top-content');
            if (task_node.length !== 0) {
                let task_width = task_node[0].offsetWidth-5;
                this.$store.commit('setCtaskWidth', task_width);
                return task_width;
            }
        },
    }
}
</script>

<style lang="scss">
    .task{
        .filterActive{
            color: #dad6d6  !important;
        }
        .el-main{
            // padding: 15px 0;
            min-height: 690px;
            background-color: #252425;
            display: flex;
            flex-wrap: wrap;
            .task-box{
                flex: 3;
            }
            .task-price-box{
                flex: 1;
                margin-right: 5px;
                .task-price-header{
                    background-color: #1e1e1e;
                    padding: 15px 0;
                    color: #686869;
                }
                .task-api-content{
                    background-color: #262829;
                    color: #686869;
                    .task-api-item{
                        text-align: left;
                        padding: 10px;
                    }
                }
            }
        }
        .task-header{
            background-color: #1e1e1e;
            display: flex;
            justify-content: space-between;
            .task-header-left{
                display: flex;
                justify-content: flex-start;
                line-height: 30px;
                select{
                    height: 30px;
                    margin-left: 10px;
                    background-color: #2a2d2e;
                    outline: none;
                    border-color: #2a2d2e;
                    color: #97979a;
                    padding-left: 3px;
                }
                span{
                    margin-left: 5px;
                    color: #97979a;
                }
            }
            .task-header-right{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .el-slider{
                    margin-right: 5px;
                    .el-slider__runway{
                        width: 40px;
                        background-color: #aaadb3;
                        .el-slider__bar{
                            background-color: #656161;
                        }
                        .el-slider__button-wrapper{
                            // width: 7px;
                            // height: 15px;
                            .el-slider__button{
                                width: 7px;
                                height: 14px;
                                background-color: #82716c;
                                border: 0;
                                border-radius: 0;
                            }
                        }
                    }
                }
                .loadding-more{
                    color:#a3db41;
                    font-size: 20px;
                }
                .el-button{
                    margin-right: 5px;
                    margin-left: 0;
                }
            }
            .el-dialog__body{
                padding: 10px;
            }
            h3{
                text-align: left;
                span{
                    font-size: 15px;
                    color: #db5634;
                }
            }
            // .el-button{
            //     padding: 5px 10px;
            //     background-color: #333333;
            //     border-color: #333333;
            //     color: #97979a;
            // }
            // .el-button:hover{
            //     color: #fff;
            // }
        }
        .task-list{
            background-color: #2A2D2E;
            padding: 5px 0 30px 0;
            min-height: 680px;
            .task-list-table-mobile{
                display: none;
            }

            .test{
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                .task-item-box{
                    flex: 1;
                    min-width: 380px;
                    padding: 0 10px;
                    // max-width: 360px;
                }
            }
            .test-loading{
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                .loadding-task{
                    color: rgb(104, 99, 99);
                    font-size: 40px;
                }
            }

            .task-list-table{
                // margin-left: 30px;
                background-color: #1e1e1e;
                padding: 10px 10px 10px 25px;
                margin-bottom: 5px;
                display: flex;
                justify-content: space-between;
                .task-list-table-right{
                    display: flex;
                    align-items: center;
                    .el-button{
                        background-color: #1e1e1e;
                        border: 1px solid #2a2d2e;
                        padding: 5px;
                        i{
                            color: #db5634;

                        }
                    }
                }
                .task-filter-box{
                    display: flex;
                    flex-wrap: wrap;
                    padding: 6px; 
                    .filter-box-item{
                        // flex: 1;
                        margin-right: 8px;
                        margin-bottom: 3px;
                        button{
                            padding: 3px 5px;
                            background-color: #2a2d2e;
                            color: #97979a;
                            outline: none;
                            border: 1px solid #2a2d2e;
                        }
                        button:hover{
                            cursor: pointer;
                            color: #fff;
                        }
                    }
                }
                table{
                    width: 100%;
                    tr{
                        th{
                            color: #97979a;
                        }
                        th:hover{
                            cursor: pointer;
                        }
                    }
                    tbody{
                        tr{
                            td{
                                color: #97979a;
                                padding: 3px;
                                .task-list-btn{
                                    .el-button{
                                        padding: 4px;
                                        // outline: none;
                                        border: 1px solid #2a2d2e;
                                        background-color: #2a2d2e;
                                        color: #97979a;
                                    }
                                }
                                .task-list-btn:hover{
                                    cursor: pointer;
                                }
                            }
                            td:hover{
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
            ul{
                padding-left: 30px;
            }
        }

        .market-chart-dialog{
            .el-dialog__body{
                background-color: #1e1e1e;
                box-shadow: 0 0 5px #fff;
                .dialog-header{
                    padding-top: 10px;
                }
                .el-divider{
                    background-color: #4e4d4d;
                    margin: 10px 0;
                }
                .dialog-content{
                    .chart-time-select{
                        text-align: left;
                        span{
                            font-size: 12px;
                            margin-left: 5px;
                        }
                        span:hover{
                            cursor: pointer;
                            color: #dad6d6;
                        }
                    }
                }
            }   
        }
    }

    @media screen and (max-width: 1100px) {
        .task{
            .el-main{
                padding: 20px 0;
                .task-list{
                    padding: 20px 0;
                    .task-list-table-mobile{
                        display: none;
                    }
                    .task-item-box{
                        min-width: 47%;
                    }
                    ul{
                        padding-left: 0;
                        .task-top-content{
                            border: 0 !important;
                        }
                    }
                }
                .task-header{
                    .el-dialog{
                        width: 400px !important;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 800px){
        .task{
            .el-main{
                .task-list{
                    padding: 10px 0;
                    .task-list-table{
                        display: none;
                    }
                    .task-item-box{
                        min-width: 100%;
                    }
                    .task-list-table-mobile{
                        display: block;
                        background-color: #1e1e1e;
                        padding: 10px 10px 10px 0px;
                        margin-bottom: 5px;
                        text-align: left;
                        select{
                            outline: none;
                            background-color: #2a2d2e;
                            border-color: #2a2d2e;
                            margin-left: 5px;
                            color: #97979a;
                            vertical-align: middle;
                            padding: 0px 4px;
                            border-radius: 3px;
                        }
                    }
                    .task-item-box{
                        padding-left: 0;
                        .task-info{
                            .task-left{
                                .task-title-box{
                                    h2{
                                        min-width: 84px;
                                    }
                                }
                               .task-left-info{
                                    .task-progress{
                                        .el-progress{
                                        //    display: none;
                                            width: 100px;
                                        }
                                        .task-avg-price{
                                            margin-left: 5px;
                                        }
                                    }
                                } 
                            }
                            .task-right{
                                .el-checkbox{
                                    display: none;
                                }
                            }
                        }
                    }
                }
                .task-header{
                    .el-dialog{
                        width: 95% !important;
                        .el-form{
                            width:98%;
                            margin: 0;
                            padding: 10px 0;
                            .el-form-item{
                                margin-bottom: 10px;
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 420px) {
        .task{
            .el-main{
                padding: 10px 0;
                .task-api-box{
                    display: none;
                }
                .market-chart-dialog{
                    .el-dialog{
                        width: 90% !important;
                    }
                }
                .task-list{
                    padding: 5px 0;
                    text-align: left;
                    .task-list-table{
                        padding: 10px 10px 10px 0;
                        .filter-box-item{
                            button{
                                font-size: 0.5rem;
                            }
                        }
                    }
                    .task-list-table-mobile{
                        select{
                            outline: none;
                            background-color: #2a2d2e;
                            border-color: #2a2d2e;
                            margin-left: 5px;
                            color: #97979a;
                            vertical-align: middle;
                            padding: 0px 4px;
                            border-radius: 3px;
                        }
                    }
                    .task-item-box{
                        min-width: 360px !important;
                        .task-top-content{
                            border-left: 0 !important;
                        }
                        padding: 0 2px;
                        .task-info{
                            padding: 10px 0;
                            .task-left{
                                display: flex;
                                flex-wrap: wrap;
                                padding: 5px;
                                h2{
                                    font-size: 36px;
                                }
                                .task-title-box{
                                    padding: 0;
                                    margin-right: 3px;
                                    min-width: 50px;
                                    h2{
                                        min-width: 48px;
                                        font-size: 28px;
                                        font-weight: 700;
                                        font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
                                    }
                                }
                                .task-status-content{
                                    display: none;
                                }
                                .task-left-info{
                                    padding: 0;
                                    font-size: 12px !important;
                                    .progress-content{
                                        margin-left: 0;
                                        span{
                                            font-size: 12px;
                                        }
                                    } 
                                    .task-progress{
                                        margin-left: 0;
                                    }
                                    .task-price-box{
                                        margin-left: 0;
                                    }
                                    .task-run-condition{
                                        margin-left: 0;
                                    }
                                    .task-left-1{
                                        .task-name-box{
                                            .task-panel-box{
                                                .panel{
                                                    height: 30px;
                                                    width: 30px;
                                                }
                                            }
                                            .task-title-box{
                                                margin-right: 0;
                                            }
                                        }
                                    }
                                }
                            }
                            .task-right{
                                padding: 0 10px;
                                // display: none;
                                .el-dropdown{
                                    font-size: 0.5rem;
                                    .task-operation{
                                        width: 20px;
                                    }
                                }
                            }
                        }
                        .ctask-info{
                            margin-left: 0;
                        }
                    }
                }
                .task-header{
                    .task-header-left{
                        h3{
                            font-size: 13px;
                        }
                        span{
                            font-size: 13px;
                        }
                    }
                    .task-header-right{
                        display: flex;
                        align-items: center;
                        button{
                            font-size: 13px;
                            padding: 4px 7px;
                        }
                    }
                    .el-dialog{
                        width: 95% !important;
                        .el-form{
                            width:98%;
                            margin: 0;
                            padding: 10px 0;
                            .el-form-item{
                                margin-bottom: 10px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
